import { render, staticRenderFns } from "./OddsDatatable.vue?vue&type=template&id=451d6880&"
import script from "./OddsDatatable.vue?vue&type=script&lang=js&"
export * from "./OddsDatatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports